// src/components/chat/ChatList.jsx
import React from 'react';
import ChatItem from './ChatItem';
import './ChatList.css';

const ChatList = ({
    chats,
    isLoading,
    currentChat,
    
    onSelectChat,
    onContextMenu,
    onTouchStart,
}) => {
    return (
        <div className="chats-list">
            {/* 1. Загрузка */}
            {isLoading && (
                <div className="chats-loading-center">
                    <div className="spinner"></div>
                    <p>Загрузка чатов...</p>
                </div>
            )}

            {/* 2. Список чатов */}
            {!isLoading && chats && chats.length > 0 && (
                chats.map(chat => (
                    <ChatItem
                        key={chat.chat_id}
                        chat={chat}
                        isActive={currentChat?.chat_id === chat.chat_id}
                        
                        onClick={() => onSelectChat(chat)}
                        onContextMenu={(e) => onContextMenu(e, chat)}
                        onTouchStart={(e) => onTouchStart(e, chat)}
                    />
                ))
            )}

            {/* 3. Нет чатов */}
            {!isLoading && (!chats || chats.length === 0) && (
                <div className="no-chats">Нет чатов</div>
            )}
        </div>
    );
};

export default ChatList;